import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=f2929972&lang=pug&"
import script from "./AddCoupon.vue?vue&type=script&lang=ts&"
export * from "./AddCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./AddCoupon.vue?vue&type=style&index=0&id=f2929972&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports